/* eslint-disable react/no-array-index-key */

import React from 'react';

import Image from 'core/sitecore/jss-proxy-components/JssImage';
import { JssImageType, JssTextType } from 'core/utils/sitecore-utils';
import * as Typo from 'core/styles/Typography';

import * as S from './LoadingContent.style';

interface ILoadingContent {
	icon: JssImageType;
	title: JssTextType;
	subTitle: JssTextType;
}

const LoadingContent = ({ icon, title, subTitle }: ILoadingContent) => {
	return (
		<S.Wrapper>
			<Image field={icon} />
			<Typo.DisplayMedium margin="24px 0 0" textAlign="center" jss={title} />
			<Typo.Body
				color="subdued"
				margin="16px 0 0"
				textAlign="center"
				jss={subTitle}
			/>
		</S.Wrapper>
	);
};

export default LoadingContent;
